import { getAtsUrl } from '../../config';
import { HttpClient } from '../../controllers/http-client/http-client';

const atsBaseUrl = getAtsUrl?.();

interface AtsClientErrorModel {
  code: string;
  message: string;
}

export class AtsHttpClient extends HttpClient {
  constructor() {
    super(atsBaseUrl);
  }
}

export class AtsHttpClientError extends Error {
  message: string;

  constructor({ code, message }: AtsClientErrorModel) {
    super();
    this.message = `[HTTPClientError] ${code} - ${message}`;

    Object.setPrototypeOf(this, AtsHttpClientError.prototype);
  }
}
